import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  header: {
    display: "flex",
    padding: "0 8px",
    alignItems: "center"
  },
  headerTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.secondary,
    lineHeight: "45px",
    "&.hasMatches": {
      color: theme.palette.text.primary
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      fontSize: 16
    }
  },
  content: {
    margin: "0 -9px"
  },
  seeAllButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgba(97, 198, 158, 1)",
    lineHeight: "17px",
    fontSize: 12,
    height: 36,
    width: "100%",
    borderRadius: 0,
    borderTop: "1px solid #eeeeee",
    textTransform: "capitalize",
    cursor: "pointer"
  }
}));
